'use client'

import { captureAnalyticsEvent } from '@/lib/analytics'
import { subscribeToNewsletter } from '@/lib/newsletter'
import { ArrowRight, Loader2 } from 'lucide-react'
import { useState, type FormEvent } from 'react'
import { toast } from 'sonner'

export function FooterNewsletter() {
  const [email, setEmail] = useState('')
  const [isNewsletterSubmitting, setIsNewsletterSubmitting] = useState(false)

  const submitNewsletter = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const website = String(new FormData(event.currentTarget).get('website') ?? '')

    captureAnalyticsEvent('newsletter_subscription_submitted', { source: 'footer' })
    setIsNewsletterSubmitting(true)

    try {
      await subscribeToNewsletter({ email, source: 'footer', website })
      captureAnalyticsEvent('newsletter_subscription_succeeded', { source: 'footer' })
      setEmail('')
      toast.success('You are on the list', { description: 'We will send new Oorva stories and experiences to your inbox.' })
    } catch {
      captureAnalyticsEvent('newsletter_subscription_failed', { source: 'footer' })
      toast.error('Could not subscribe', { description: 'Please try again in a moment.' })
    } finally {
      setIsNewsletterSubmitting(false)
    }
  }

  return (
    <form
      onSubmit={submitNewsletter}
      className="relative mt-4 flex overflow-hidden rounded-full border border-white/12 bg-primary-dark/40 p-1.5 focus-within:border-white/30"
    >
      <input name="website" tabIndex={-1} autoComplete="off" aria-hidden="true" className="absolute -left-[9999px]" />
      <input
        type="email"
        value={email}
        onChange={(event) => setEmail(event.target.value)}
        required
        placeholder="Email address"
        aria-label="Email address"
        className="min-w-0 flex-1 bg-transparent px-3 text-sm text-white outline-none placeholder:text-white/32"
      />
      <button
        type="submit"
        aria-label="Subscribe"
        disabled={isNewsletterSubmitting}
        className="grid size-10 shrink-0 place-items-center rounded-full bg-white text-primary transition hover:bg-brand-soft disabled:cursor-not-allowed disabled:opacity-60"
      >
        {isNewsletterSubmitting ? <Loader2 className="size-4 animate-spin" /> : <ArrowRight className="size-4" />}
      </button>
    </form>
  )
}
